import React, { useEffect, useMemo } from 'react';

import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { Container } from 'app/components';
import { SectionInfo, SectionInfoTitle, SectionInfoContent, SectionTop } from '../styles';



const PrivacyPolicy = ({ footerPrivacyPolicy }) => {
  const [t, i18n] = useTranslation();

  const privacyPolicyData = useSelector(state => state?.technologies?.privacyPolicy[0]);

  useEffect(() => {
    footerPrivacyPolicy();
  }, []);

  const languageContents = useMemo(
    () => ({
      privacyPolicy: i18n.language === 'en' || i18n.language === 'en-US' ? 'privacypolicyEN' : 'privacypolicy',
    }),
    [i18n.language]
  );

  return (
    <SectionInfo>
      <Container>
        <SectionInfoTitle>{t('info.privacy_title')}</SectionInfoTitle>
        <SectionInfoContent>
          <SectionTop>
            <span
              className="privacyPolicy__description"
              dangerouslySetInnerHTML={{
                __html: privacyPolicyData?.[languageContents.privacyPolicy]
              }}
            />
          </SectionTop>
        </SectionInfoContent>
      </Container>
    </SectionInfo>
  );
};


export default PrivacyPolicy;
